<div class="banner">
  <div class="overlay">
    <div class="container">
      <h1>{{ slider[0].title }}</h1>
      <p class="content">{{ slider[0].desc }}</p>
    </div>
  </div>
  <img class="banner-image" src="{{ env + banner_image }}" alt="white-paper" />
</div>
